<script setup lang="ts">
const { colors } = useTheme()
const filters = useFilters()

const isPremium = computed({
  get: () => filters.value.is_premium ?? false,
  set: (value: boolean) => filters.value.is_premium = value,
})
</script>

<script lang="ts">
export default defineComponent({
  name: 'FilterPremium',
})
</script>

<template>
  <FormToggle v-model="isPremium" toggle-position="start" class="<sm:gap-1">
    <template #label>
      <Text :color="isPremium ? colors.softBlack : colors.bluishSofter" class="!text-[12px] !md:text-[14px]">
        Premium
      </Text>
    </template>
  </FormToggle>
</template>
